import type React from 'react';

import { ButtonGroup, FormField, Label } from '@zillow/constellation';

import InlineTooltip from '../../../Widgets/InlineTooltip';

type Props = {
  children: React.ReactNode;
};

export default function PetsBaseRentButtonGroup({ children }: Props) {
  return (
    <FormField
      label={
        <Label>
          Is there a pet charge in addition to the{' '}
          <InlineTooltip tooltipBodyText="Base rent is the rent before other fees such as parking or utilities are added.">
            base rent
          </InlineTooltip>
          ?
        </Label>
      }
      control={
        <ButtonGroup direction="column" conjoined fluid area-label="pets-charge-type">
          {children}
        </ButtonGroup>
      }
    />
  );
}
